import { grid3Categories } from '@/mocks/categories';

export default function CategoryGrid3() {
  return (
    <section className="relative py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="mb-10 md:mb-14">
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950 leading-tight">
            Even More<br />
            <span className="italic font-medium text-secondary-500">To Discover</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-5 md:gap-6">
          {grid3Categories.map((cat, idx) => {
            const bgColors = [
              'bg-[#f0e8dc]',
              'bg-[#e4dcd4]',
              'bg-[#e8e0d8]',
            ];
            return (
              <a
                key={cat.seq}
                href={cat.url}
                target="_blank"
                rel="noopener nofollow"
                className="group block rounded-2xl overflow-hidden bg-white hover:scale-[1.02] transition-transform duration-300 cursor-pointer"
              >
                <div className={`h-[260px] md:h-[320px] ${bgColors[idx]} flex items-center justify-center p-6`}>
                  <img
                    src={cat.imageUrl}
                    alt={`CSSBuy ${cat.name} Spreadsheet`}
                    title={`CSSBuy ${cat.name} Spreadsheet`}
                    className="w-full h-full object-cover object-center rounded-xl"
                    loading="lazy"
                  />
                </div>
                <div className="px-5 py-4">
                  <h3 className="font-heading text-lg font-semibold text-foreground-900">
                    {cat.name}
                  </h3>
                  <p className="text-xs text-foreground-500 mt-1 border-b border-foreground-200 pb-1 inline-block">
                    Browse collection &rarr;
                  </p>
                </div>
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
}